export default __webpack_public_path__ + "static/media/Icons_User Icon.d9d167da.svg";